import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

import { init } from '@fullstory/browser';
import { isFullstoryEnabled } from './app/shared/services/fullstory/fullstory.service';

if (isFullstoryEnabled()) {
  init({ orgId: 'o-24CGB4-na1', devMode: false });
}

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch((err) => console.error(err));
